module.exports = __webpack_public_path__ + "static/media/pt.b63083c9.svg";